/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { ProcessWorkflowModel } from '../models';
// @ts-ignore
import type { WorkflowResponseModel } from '../models';
/**
 * WorkflowApi - axios parameter creator
 * @export
 */
export const WorkflowApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all tasks of a given workflow
         * @summary fetch all tasks of given workflow
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowTasks: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkflowTasks', 'id', id)
            const localVarPath = `/api/v1/workflow/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Process a given task of the workflow
         * @summary Process a given task of the workflow
         * @param {ProcessWorkflowModel} processWorkflowModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processWorkflow: async (processWorkflowModel: ProcessWorkflowModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processWorkflowModel' is not null or undefined
            assertParamExists('processWorkflow', 'processWorkflowModel', processWorkflowModel)
            const localVarPath = `/api/v1/workflow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processWorkflowModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * sets the current task as previous one
         * @summary sets the current task as previous one
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowBack: async (requestBody: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('workflowBack', 'requestBody', requestBody)
            const localVarPath = `/api/v1/workflow/back`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkflowApi - functional programming interface
 * @export
 */
export const WorkflowApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkflowApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all tasks of a given workflow
         * @summary fetch all tasks of given workflow
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkflowTasks(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkflowTasks(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkflowApi.getWorkflowTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Process a given task of the workflow
         * @summary Process a given task of the workflow
         * @param {ProcessWorkflowModel} processWorkflowModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processWorkflow(processWorkflowModel: ProcessWorkflowModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processWorkflow(processWorkflowModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkflowApi.processWorkflow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * sets the current task as previous one
         * @summary sets the current task as previous one
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workflowBack(requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workflowBack(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkflowApi.workflowBack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkflowApi - factory interface
 * @export
 */
export const WorkflowApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkflowApiFp(configuration)
    return {
        /**
         * Get all tasks of a given workflow
         * @summary fetch all tasks of given workflow
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowTasks(id: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkflowResponseModel> {
            return localVarFp.getWorkflowTasks(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Process a given task of the workflow
         * @summary Process a given task of the workflow
         * @param {ProcessWorkflowModel} processWorkflowModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processWorkflow(processWorkflowModel: ProcessWorkflowModel, options?: RawAxiosRequestConfig): AxiosPromise<WorkflowResponseModel> {
            return localVarFp.processWorkflow(processWorkflowModel, options).then((request) => request(axios, basePath));
        },
        /**
         * sets the current task as previous one
         * @summary sets the current task as previous one
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowBack(requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): AxiosPromise<WorkflowResponseModel> {
            return localVarFp.workflowBack(requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkflowApi - interface
 * @export
 * @interface WorkflowApi
 */
export interface WorkflowApiInterface {
    /**
     * Get all tasks of a given workflow
     * @summary fetch all tasks of given workflow
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApiInterface
     */
    getWorkflowTasks(id: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkflowResponseModel>;

    /**
     * Process a given task of the workflow
     * @summary Process a given task of the workflow
     * @param {ProcessWorkflowModel} processWorkflowModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApiInterface
     */
    processWorkflow(processWorkflowModel: ProcessWorkflowModel, options?: RawAxiosRequestConfig): AxiosPromise<WorkflowResponseModel>;

    /**
     * sets the current task as previous one
     * @summary sets the current task as previous one
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApiInterface
     */
    workflowBack(requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): AxiosPromise<WorkflowResponseModel>;

}

/**
 * WorkflowApi - object-oriented interface
 * @export
 * @class WorkflowApi
 * @extends {BaseAPI}
 */
export class WorkflowApi extends BaseAPI implements WorkflowApiInterface {
    /**
     * Get all tasks of a given workflow
     * @summary fetch all tasks of given workflow
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    public getWorkflowTasks(id: string, options?: RawAxiosRequestConfig) {
        return WorkflowApiFp(this.configuration).getWorkflowTasks(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Process a given task of the workflow
     * @summary Process a given task of the workflow
     * @param {ProcessWorkflowModel} processWorkflowModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    public processWorkflow(processWorkflowModel: ProcessWorkflowModel, options?: RawAxiosRequestConfig) {
        return WorkflowApiFp(this.configuration).processWorkflow(processWorkflowModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * sets the current task as previous one
     * @summary sets the current task as previous one
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    public workflowBack(requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig) {
        return WorkflowApiFp(this.configuration).workflowBack(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}

